import React from "react";
import styled from "styled-components";
import TextView from "../../../components/TextView";
import Button from "../../../components/Button";
import { colors } from "../../../utils";
import BG from "assets/images/ref-banner.png";

const Container = styled.div`
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  height:180px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Centered = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: left;
  display: grid;
  grid-row-gap: 10px;
`;

export default function Header({
  title,
  text,
  buttonText,
  onButtonPress,
  color,
  disabled
}) {
  return (
    <Container style={{ backgroundColor: color }}>
      <Image src={BG} />
      <Centered>
        <TextView
          variant="largeTitle"
        >
          {title}
        </TextView>
        {text ? <TextView variant="subtitle">{text}</TextView> : null}
        {buttonText ? (
          <Button
            onClick={onButtonPress}
            disabled={disabled}
            style={{
              width: 160,
              
              marginTop: 10,
            }}
          >
            {buttonText}
          </Button>
        ) : null}
      </Centered>
    </Container>
  );
}
